import React from 'react';
import { Icon } from '@ver-uds/uswds-react';
import I9Constants from '../I9Constants/I9Constants';
import './ViewMyI9Training.scss';
import AriaLink from '../AriaLink/AriaLink';
import LinkType from '../../constants/LinkType';
import I9TrainingVideo from '../I9TrainingVideo/I9TrainingVideo';

const ViewMyI9Training = (): JSX.Element => {
  const evePlusResourceLink = (link: string, linkText: string, linkTitle?: string): JSX.Element => {
    return (
      <div className="resource-link">
        <Icon name="file_present" />
        <AriaLink link={link} linkType={LinkType.DOCUMENT} customLinkText={linkText} customTitle={linkTitle} />
      </div>
    );
  };

  return (
    <>
      <div className="section">
        <h1 data-testid="view-my-i9-training" className="margin-0 padding-bottom-2">
          View {I9Constants.PROGRAM_NAME} Training
        </h1>
        <p>{I9Constants.I9_INTRO_TEXT}</p>
      </div>
      <div className="section view-training-video-section">
        <I9TrainingVideo />
      </div>
      <div className="section view-training-resources">
        <h4 className="resources-title">Resources</h4>
        <ul className="resources-list">
          <li>
            {evePlusResourceLink(
              'https://www.e-verify.gov/sites/default/files/everify/infosheets/E-VerifyPlusInformationSheetforEmployees.pdf',
              'E-Verify+ Information Sheet for Employees',
            )}
          </li>
          <li>
            {evePlusResourceLink(
              'https://www.e-verify.gov/sites/default/files/everify/infosheets/E-VerifyPlusInformationSheetforEmployers.pdf',
              'E-Verify+ Information Sheet for Employers',
            )}
          </li>
          <li>
            {evePlusResourceLink(
              'https://www.e-verify.gov/sites/default/files/everify/infosheets/E-VerifyPlusPendingSSNorReceiptInfo.pdf',
              'E-Verify+ Employer Information Sheet for a Pending Social Security Number or Receipt for a Lost, Stolen or Damaged Document',
              'E-Verify+ Pending SSN or Receipt Information Sheet',
            )}
          </li>
        </ul>
      </div>
    </>
  );
};

export default ViewMyI9Training;
